var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.6C9.9149 1.6 11.5572 2.46296 12.6455 4H9.6V5.6H15.2V0H13.6V2.61628C12.2199 0.946009 10.2434 0 8 0C3.58172 0 0 3.58172 0 8H1.6C1.6 4.46538 4.46538 1.6 8 1.6ZM8 14.4C6.0851 14.4 4.44283 13.537 3.35445 12H6.4V10.4H0.8V16H2.4V13.3837C3.78009 15.054 5.75661 16 8 16C12.4183 16 16 12.4183 16 8H14.4C14.4 11.5346 11.5346 14.4 8 14.4Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingIcon);
export default __webpack_public_path__ + "static/media/loadingIcon.fc54b94d54a7947024a7bc4cf2048fa0.svg";
export { ForwardRef as ReactComponent };